import { render, staticRenderFns } from "./ProjectTeamListSelector.vue?vue&type=template&id=64dba3fb&scoped=true&"
import script from "./ProjectTeamListSelector.vue?vue&type=script&lang=ts&"
export * from "./ProjectTeamListSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectTeamListSelector.vue?vue&type=style&index=0&id=64dba3fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dba3fb",
  null
  
)

export default component.exports